import { render, staticRenderFns } from "./MapaNotificacao.vue?vue&type=template&id=efae4618&"
import script from "./MapaNotificacao.vue?vue&type=script&lang=js&"
export * from "./MapaNotificacao.vue?vue&type=script&lang=js&"
import style0 from "./MapaNotificacao.vue?vue&type=style&index=0&id=efae4618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports